import { Typography } from '@material-ui/core';
import { ThumbUp } from '@material-ui/icons';
import { Column, Columns, Inline, Stack } from '@superdispatch/ui';
import { MouseEvent } from 'react';
import { formatPlural } from 'shared/helpers/IntlHelpers';
import { ShipperProfileLink } from 'shared/modules/shipper/ShipperProfileLink';
import { WebViewPhoneLink } from 'shared/routing/WebViewLinks';
import {
  displayShipperVehiclesCount,
  PostingShipperDTO,
} from '../../data/dto/PostingLoadDTO';
import { trackLoadboardEvent } from '../LoadboardAnalytics';
import { PostingShipperUnverifiedBadge } from './PostingShipperUnverifiedBadge';

interface PostingShipperDetailsProps {
  shipper: PostingShipperDTO;
}

export function PostingShipperDetails({ shipper }: PostingShipperDetailsProps) {
  return (
    <Stack space="xsmall">
      <Columns space="xsmall">
        <Column>
          <Inline verticalAlign="center">
            <ShipperProfileLink
              guid={shipper.guid}
              medium="Load Details"
              onClick={(event: MouseEvent) => {
                event.stopPropagation();
              }}
            >
              {shipper.name}
            </ShipperProfileLink>
            {shipper.verification_status === 'NOT_APPROVED' && (
              <PostingShipperUnverifiedBadge
                externalNotes={shipper.external_notes}
              />
            )}
          </Inline>
        </Column>

        <Column width="content">
          <Inline space="xxsmall" verticalAlign="center">
            <ThumbUp fontSize="small" color="action" />

            <ShipperProfileLink
              aria-label="shipper rating percentage"
              guid={shipper.guid}
              medium="Load Details"
              tab="ratings"
              onClick={(event: MouseEvent) => {
                event.stopPropagation();
              }}
            >
              {shipper.rating_details?.overall_rating || 0}%
            </ShipperProfileLink>

            {!!shipper.rating_details?.total_rating_count && (
              <Typography>
                ({shipper.rating_details.total_rating_count})
              </Typography>
            )}
          </Inline>
        </Column>
      </Columns>

      <WebViewPhoneLink
        tel={shipper.contact_phone}
        onClick={(event: MouseEvent<HTMLAnchorElement>) => {
          event.stopPropagation();
          trackLoadboardEvent({
            name: 'SLB: Clicked Shipper Phone In Load Details',
          });
        }}
      />

      {(shipper.accepted_loads_count != null ||
        shipper.overall_moved_vehicles_count != null) && (
        <div>
          {shipper.accepted_loads_count != null && (
            <Typography aria-label="Accepted loads" gutterBottom={true}>
              <b>{shipper.accepted_loads_count}</b>{' '}
              {formatPlural(shipper.accepted_loads_count, 'load', 'loads')}{' '}
              accepted by you
            </Typography>
          )}
          {shipper.overall_moved_vehicles_count != null && (
            <Typography aria-label="Vehicles moved by shipper">
              <b>
                {displayShipperVehiclesCount(
                  shipper.overall_moved_vehicles_count,
                )}
              </b>{' '}
              vehicles moved overall
            </Typography>
          )}
        </div>
      )}
    </Stack>
  );
}
